import { useState } from "react";
import { resourceEntries } from "@/mocks/home";

export default function ResourceEntries() {
  const [toast, setToast] = useState<string | null>(null);

  const handleClick = (title: string) => {
    setToast(`「${title}」为演示入口，本页仅作展示，暂不提供实际下载。`);
    window.setTimeout(() => setToast(null), 2600);
  };

  return (
    <section id="resources" className="w-full bg-gradient-to-b from-background-100 to-background-50">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-bold text-accent-900">
              <i className="ri-download-cloud-2-line text-sm"></i>
              资源 / 入口专区
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              一键进入 · 集中获取
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              资料包、图集、关系图谱与更新提醒都收在这一区，入口固定、随取随用，不用再翻聊天记录找链接。
            </p>
          </div>
          <a
            href="#discussion"
            className="flex h-11 w-fit items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 text-sm font-bold text-background-50 transition-colors hover:bg-accent-600 dark:text-foreground-950 cursor-pointer"
          >
            <i className="ri-stack-line text-base"></i>
            全部资源一览
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {resourceEntries.map((entry) => (
            <article
              key={entry.id}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-accent-300"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-accent-100 text-accent-800">
                  <i className={`${entry.icon} text-2xl`}></i>
                </span>
                <span className="rounded-full bg-background-200/80 px-2.5 py-1 text-[11px] font-semibold text-foreground-600">
                  {entry.meta}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{entry.title}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{entry.desc}</p>
              <button
                type="button"
                onClick={() => handleClick(entry.title)}
                className="mt-5 flex h-10 items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950 cursor-pointer"
              >
                <i className="ri-arrow-right-circle-line text-base"></i>
                {entry.action}
              </button>
            </article>
          ))}
        </div>
      </div>

      {toast && (
        <div className="fixed bottom-6 left-1/2 z-50 -translate-x-1/2 px-4">
          <div className="flex items-center gap-2 rounded-lg bg-foreground-950 px-4 py-3 text-sm text-background-50 shadow-lg">
            <i className="ri-information-line text-base text-accent-400"></i>
            {toast}
          </div>
        </div>
      )}
    </section>
  );
}